import { render, staticRenderFns } from "./ticket-details.vue?vue&type=template&id=7b397410&scoped=true&"
import script from "./ticket-details.vue?vue&type=script&lang=js&"
export * from "./ticket-details.vue?vue&type=script&lang=js&"
import style0 from "./ticket-details.vue?vue&type=style&index=0&id=7b397410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b397410",
  null
  
)

export default component.exports